<template>
  <div class="container">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/websites' }">概览</el-breadcrumb-item>
        <el-breadcrumb-item>站点管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <template>
      <el-row>
        <el-input v-model="keywords" placeholder="请输入站点或域名关键字" clearable style="width: 300px; margin-right: 10px;"
          @keyup.enter.native="searchList()"
          @clear="searchList()"></el-input>
        <el-button @click="searchList()" icon="el-icon-search" circle title="查询"></el-button>
        <el-button @click="add()" icon="el-icon-plus" circle title="添加"></el-button>
      </el-row>
      <br>
      <el-table ref="websiteListTable" :data="listData" border style="width: 100%" height="650" stripe v-loading="loading">
        <el-table-column prop="title" label="站点" width="240" fixed>
          <template v-slot="scope">
            <el-link type="primary" @click="manage(scope.row)" title="点击进入管理">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="domain" label="域名" width="240">
          <template v-slot="scope">
            <el-link type="primary" @click="goto(scope.row.domain)" title="点击访问">{{ scope.row.domain }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="100">
          <template v-slot="scope">
            <el-switch v-model="scope.row.status" active-color="#13ce66" inactive-color="#ccc"
              @change="toggleStatus(scope.row, scope.$index)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="main_product" label="主产品" width="240"></el-table-column>
        <el-table-column prop="main_email" label="主邮箱" width="240"></el-table-column>
        <el-table-column prop="saler_name" label="业务员" width="150"></el-table-column>
        <el-table-column prop="creator_name" label="负责人"></el-table-column>
        <el-table-column prop="created_at" label="创建时间" width="240"></el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template v-slot="scope">
            <el-link type="primary" :underline="false" @click="view(scope.row)" class="text-small">预览</el-link>
            <el-link type="primary" :underline="false" @click="manage(scope.row)" class="text-small">管理</el-link>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <br>
    <div class="pagenation">
      <el-pagination background layout="total, sizes, prev, pager, next" :total="total" @size-change="changeSize"
        @current-change="currentChange" :page-sizes="[10, 20, 50, 100]" :page-size="size" :current-page="page">
      </el-pagination>
    </div>

    <el-dialog title="添加网站" :visible.sync="addVisible" :close-on-click-modal="false" style="margin-top: -80px;">
      <el-form :model="addForm" label-width="120px" :rules="addRules" ref="addForm" v-loading="addLoading"
        element-loading-text="正在添加站点, 请稍候">
        <el-form-item label="网站名称" prop="title">
          <el-col :span="12">
            <el-input placeholder="请输入网站名称" v-model="addForm.title"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="域名" prop="domain">
          <el-col :span="12">
            <el-input placeholder="xxx.com" v-model="addForm.domain"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="网站类型" prop="type">
          <el-col :span="24">
            <el-radio-group v-model="addForm.type">
              <el-radio label="工厂型">工厂型</el-radio>
              <el-radio label="贸易型">贸易型</el-radio>
              <el-radio label="集团站">集团站</el-radio>
            </el-radio-group>
          </el-col>
        </el-form-item>
        <el-form-item label="主邮箱" prop="main_email">
          <el-col :span="12">
            <el-input placeholder="网站上的邮箱" v-model="addForm.main_email"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="主产品" prop="main_product">
          <el-col :span="12">
            <el-input placeholder="文案主题" v-model="addForm.main_product"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="业务员" prop="saler_id">
          <el-select v-model="addForm.saler_id" placeholder="网站上的联系人" filterable clearable>
            <el-option v-for="item in salers" :key="item.id" :label="item.saler" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="建站规则" prop="avoid_ai_type">
          <el-select v-model="addForm.avoid_ai_type" filterable clearable>
            <el-option label="规则T" value="天工开物"></el-option>
            <el-option label="规则M" value="梦溪笔谈"></el-option>
            <el-option label="规则B" value="本草纲目"></el-option>
            <el-option label="规则B1" value="本草纲目拾遗"></el-option>
            <el-option label="规则S" value="山海经"></el-option>
            <el-option label="规则K" value="开煤要法"></el-option>
            <el-option label="规则Z" value="植物名实图考"></el-option>
            <el-option label="规则U" value="无"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmAdd()">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Nav from '../../Global/Nav.vue'
const WEBSITE_LIST_STATE_KEY = 'websites:list:state'

export default {
  name: 'WebsitesList',
  components: {
    Nav
  },
  data() {
    return {
      salers: [],
      keywords: '',
      listData: [],
      loading: true,
      total: 0,
      page: 1,
      size: 10,
      savedScrollTop: 0,
      addVisible: false,
      addLoading: false,
      addForm: {
        title: '',
        domain: '',
        type: '',
        main_email: '',
        deputy_email: 'sophiahoney247@gmail.com',
        main_product: '',
        saler_id: '',
        avoid_ai_type: '天工开物'
      },
      addRules: {
        title: [
          { required: true, message: '网站名称不能为空', trigger: 'commit' }
        ],
        domain: [
          { required: true, message: '域名不能为空', trigger: 'commit' }
        ],
        main_product: [
          { required: true, message: '主产品不能为空', trigger: 'commit' }
        ],
        main_email: [
          { required: true, message: '主邮箱不能为空', trigger: 'commit' },
          {
            pattern: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
            message: '请输入合法的邮箱地址',
            trigger: 'commit'
          }
        ],
        saler_id: [
          { required: true, message: '业务员必选', trigger: 'commit' }
        ]
      }
    }
  },
  mounted() {
    if (this.restoreListState()) {
      this.loading = false;
      this.restoreScrollTop();
      this.bindTableScroll();
      return;
    }

    this.getList().then(() => {
      this.restoreScrollTop();
      this.bindTableScroll();
    });
  },
  beforeDestroy() {
    this.saveListState();
  },
  methods: {
    async getList() {
      this.loading = true;
      await this.$axios.get(`/websites/backend/list`, {
        params: {
          keywords: this.keywords,
          page: this.page,
          size: this.size
        }
      }).then((response) => {
        this.loading = false;
        if (response.data.code === 200) {
          this.listData = response.data.data.data;
          this.total = response.data.data.total;
          this.saveListState();
        }
      });
    },
    searchList() {
      this.page = 1;
      this.saveListState();
      this.getList();
    },
    view(row) {
      const url = 'http://' + row.access + '.web.fluoride.ltd';
      const windowFeatures = 'toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=yes,resizable=yes,fullscreen=yes,channelmode=yes';
      window.open(url, '_blank', windowFeatures);
    },
    manage(row) {
      this.saveListState();
      this.$router.push({
        name: 'websites_detail',
        params: {
          domain: row.domain
        }
      });
    },
    goto(url) {
      window.open('http://www.' + url, '_blank');
    },
    toggleStatus(row, index) {
      let id = row.id;
      let notice = row.status ? '确定开启吗?' : '关闭后网站将无法访问, 确定吗?';
      let message = row.status ? '开启' : '关闭';
      this.$confirm(notice, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/websites/backend/toggle_status', {
          id: row.id,
          status: row.status
        }).then((response) => {
          if (response.data.code === 200) {
            this.$notify({
              title: '操作成功',
              message: row.title + ' 已经' + message,
              type: 'success'
            });
          }
        })
      }).catch(() => {
        this.listData[index].status = !row.status;
      });
    },
    async add() {
      await this.$axios.get(`/websites/backend/salers`).then((response) => {
        if (response.data.code === 200) {
          this.salers = response.data.data
        }
      })
      this.addForm = {
        title: '',
        domain: '',
        type: '',
        main_email: '',
        deputy_email: 'sophiahoney247@gmail.com',
        main_product: '',
        saler_id: '',
        avoid_ai_type: '天工开物'
      }
      this.addVisible = true;
    },
    confirmAdd() {
      this.$refs.addForm.validate(valid => {
        if (valid) {
          this.addLoading = true;
          this.$axios.post('/websites/backend/store',
            this.addForm
          ).then((response) => {
            this.addLoading = false;
            if (response.data.code === 200) {
              this.getList();
              this.addVisible = false;
            }
          }).catch(function () {
            this.addLoading = false;
          })
        }
      })
    },
    changeSize(val) {
      this.size = val;
      this.page = 1;
      this.saveListState();
      this.getList();
    },
    currentChange(val) {
      this.page = val;
      this.saveListState();
      this.getList();
    },
    getTableBodyWrapper() {
      return this.$refs.websiteListTable && this.$refs.websiteListTable.bodyWrapper;
    },
    getScrollTop() {
      const wrapper = this.getTableBodyWrapper();
      return wrapper ? wrapper.scrollTop : 0;
    },
    bindTableScroll() {
      const wrapper = this.getTableBodyWrapper();
      if (!wrapper || wrapper.__websiteListScrollBinded) {
        return;
      }

      wrapper.__websiteListScrollBinded = true;
      wrapper.addEventListener('scroll', () => {
        this.saveListState();
      });
    },
    saveListState() {
      sessionStorage.setItem(WEBSITE_LIST_STATE_KEY, JSON.stringify({
        keywords: this.keywords,
        page: this.page,
        size: this.size,
        scrollTop: this.getScrollTop(),
        total: this.total,
        listData: this.listData
      }));
    },
    restoreListState() {
      let state = {};

      try {
        state = JSON.parse(sessionStorage.getItem(WEBSITE_LIST_STATE_KEY) || '{}');
      } catch (e) {
        state = {};
      }

      this.keywords = state.keywords || '';
      this.page = state.page || 1;
      this.size = state.size || 10;
      this.savedScrollTop = state.scrollTop || 0;
      this.total = state.total || 0;
      this.listData = Array.isArray(state.listData) ? state.listData : [];

      return this.listData.length > 0;
    },
    restoreScrollTop() {
      this.$nextTick(() => {
        const wrapper = this.getTableBodyWrapper();

        if (wrapper) {
          wrapper.scrollTop = this.savedScrollTop || 0;
        }
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Modules/Websites/List.vue